// extracted by mini-css-extract-plugin
export default {"page":"PracticeDetailsPage_page__sAOLo"};